// Generated by Melange

import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as JsxRuntime from "react/jsx-runtime";

function AuthErrorForm(Props) {
  let payload = Props.payload;
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "AuthErrorPayload")) {
    const payload$1 = payload.VAL;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
                  children: payload$1.message,
                  className: "text-alert"
                }),
            JsxRuntime.jsx("p", {
                  children: payload$1.reason
                })
          ],
          className: "flex flex-col space-y-2"
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "Произлошла ошибка, но мы не можем определить точную причину."
        });
  }
  return JsxRuntime.jsx(Buhta_cabinet__Box.make, {
              title: "Ошибка",
              className: "relative",
              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    children: tmp
                  })
            });
}

const make = AuthErrorForm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
